//import Foundation from 'foundation-sites';
import './lib/foundation-explicit-pieces';
import { WOW } from 'wowjs';

window.$ = $;
window.WOW = WOW;

$(document).ready(function () {
	$(document).foundation();

	//Initialization of Header, Hamburger & Mansory when Page is ready
	init();

	//Search
	$('input[name="awsm_radio_1"]').change(function(){
	 if($('#awsm_radio_1_5').is(':checked')) {
		 $('#awsm_text_3').show();
	 } else {
		 $('#awsm_text_3').hide();
	 }
 });

	$('.js-open-search').on('click', function(){
  $('.js-search').removeClass('translate-y-full');
  $('.ajax-search input[type="search"]').focus();
	});
	$('.js-close-search').on('click', function(){
	  $('.js-search').addClass('translate-y-full');
	});


	//HIDE BETREIBSLEITERIN IMG IF DOESN"T EXISt
	if ($('.dokumente-inner-wrapper').find('input').length === 0) {
		$('.dokumente-inner-wrapper').addClass('empty')
	}
	if ($('.betriebsleiterin').find('img').length > 0) {
		if ($('.betriebsleiterin').find('img').attr('src').length === 0) {
			$('.betriebsleiterin').hide();
		}
	}
	//HIDE BETREIBSLEITERIN IMG IF DOESN"T EXISt END
	//MULTIPLE DOWNLOADS ON CLICK
	$('#download_all').on('click', function (e) {
		var filesForDownload = [];
		$.each($('.document:checked'), function (index, value) {
			filesForDownload.push({ path: value.dataset.url, name: value.title })
		});

		e.preventDefault();

		var temporaryDownloadLink = document.createElement("a");
		temporaryDownloadLink.style.display = 'none';

		document.body.appendChild(temporaryDownloadLink);

		var n = 0, howManyTimes = filesForDownload.length;
		function wait() {
			var download = filesForDownload[n];
			temporaryDownloadLink.setAttribute('target', '_blank');
			temporaryDownloadLink.setAttribute('href', download.path);
			temporaryDownloadLink.setAttribute('download', download.name);

			temporaryDownloadLink.click();
			n++;
			if (n < howManyTimes) {
				setTimeout(wait, 1500);
			}
		}
		wait();
		document.body.removeChild(temporaryDownloadLink);
	});
	//MULTIPLE DOWNLOADS ON CLICK END

	$('.regular').slick({
		dots: true,
		arrows: true,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
	});

	$('.media-slider').slick({
		dots: false,
		arrows: true,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
	});

	$('.carousel').slick({
		infinite: true,
		dots: true,
		arrows: false,
		slidesToShow: 4,
		slidesToScroll: 2,
		autoplay: true,
		autoplaySpeed: 2000,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true,
					dots: true,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					dots: false,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: false,
				},
			},
		],
	});


	$('[data-menu-square] > li > a').addClass('square');
	$('[data-menu-underline-from-center] > li > a').addClass('underline-from-center');
	$('[data-menu-underline-from-center] p a').addClass('underline-from-center');
	$('[data-submenu-underline-from-center] > li > a').addClass('underline-from-center');


	//WERTBLUME
	$('g').on('click',function () {
		if ($('g').parent().parent().hasClass('clicked') & !($(this).parent().parent().hasClass('clicked'))) {
			$('.wertblume-desktop>.wp-block-group').prependTo($('.clicked'))
			$('g').parent().parent().removeClass('clicked');
			$(this).parent().parent().addClass('clicked')
			$(this).parent().parent().find('.wp-block-group').appendTo($(this).parent().parent().parent())
		}
		else if ($('g').parent().parent().hasClass('clicked') & ($(this).parent().parent().hasClass('clicked'))) {
			$('.wertblume-desktop>.wp-block-group').prependTo($('.clicked'))
			$(this).parent().parent().removeClass('clicked');
		}
		else {
			$(this).parent().parent().addClass('clicked')
			$(this).parent().parent().find('.wp-block-group').appendTo($(this).parent().parent().parent())
		}
		var wertblume = $('.wertblume-desktop');
		var blumeheight = $('.wertblume-desktop').find('.wp-block-column').first().find('svg').height();
		wertblume.css('height', blumeheight)
	});
	if ($('.wertblume-desktop').length) {
		var wertblume = $('.wertblume-desktop');
		var blumeheight = $('.wertblume-desktop').find('.wp-block-column').first().find('svg').height();
		wertblume.css('height', blumeheight)
		$(window).on('resize', function () {
			var blumeheight = $('.wertblume-desktop').find('.wp-block-column').first().find('svg').height();
			wertblume.css('height', blumeheight)
		});
	}
	//WERTBLUME END

	//KONTAKT
	var emailLink = window.location.origin + "/wp-json/wp/v2/kimi_standort?_fields=email,standort,id,title,betreuungstage&per_page=100"
	function displayAvailableOptions() {
		$('div.krippe_halber-tag').hide();
		$('div.krippe_halber-tag_mittag').hide();
		$('div.krippe_halber-tag_ohne-mittag').hide();
		$('div.hort_halber-tag_mittag').hide();
		$('div.hort_halber-tag_ohne-mittag').hide();
		$('div.mittagstisch').hide();
		$('div.morgenbetreuung').hide();
		var select = $('select[name="KitaAuswahl"')[0]
		if (select.value === "Wählen Sie Ihre Kita") {
			$('div.betreuungstage-wrapper').show();
			$('div.hort-wrapper').show();
			$('div.mittagstisch-wrapper').show();
			$('div.krippe_halber-tag').show();
			$('div.krippe_halber-tag_mittag').show();
			$('div.krippe_halber-tag_ohne-mittag').show();
			$('div.hort_halber-tag_mittag').show();
			$('div.hort_halber-tag_ohne-mittag').show();
			$('div.mittagstisch').show();
			$('div.morgenbetreuung').show();
		}
		if (!(select.value === "Wähle deine Kita")) {
			$.get(emailLink, function (data) {
				var valueSelected = select.value;
				emailAddress = data.find(x => x.title.rendered === valueSelected).email
				var betreuungsTage = data.find(x => x.title.rendered === valueSelected).betreuungstage
				$.each(betreuungsTage, function (index, value) {
					if (value === "krippe_halber-tag" || value === "krippe_halber-tag_mittag" || value === "krippe_halber-tag_ohne-mittag") {
						$('div.betreuungstage-wrapper').show();
					}
					if (value === "hort_halber-tag_mittag" || value === "hort_halber-tag_ohne-mittag") {
						$('div.hort-wrapper').show();
					}
					if (value === "mittagstisch" || value === "morgenbetreuung") {
						$('div.mittagstisch-wrapper').show();
					}
					$('div.' + value).show();
				});
				if ($('div.krippe_halber-tag').is(':hidden') && $('div.krippe_halber-tag_mittag').is(':hidden') && $('div.krippe_halber-tag_ohne-mittag').is(':hidden')) {
					$('div.betreuungstage-wrapper').hide();
				}
				if ($('div.hort_halber-tag_mittag').is(':hidden') && $('div.hort_halber-tag_ohne-mittag').is(':hidden')) {
					$('div.hort-wrapper').hide();
				}
				if ($('div.mittagstisch').is(':hidden') && $('div.morgenbetreuung').is(':hidden')) {
					$('div.mittagstisch-wrapper').hide();
				}

				$('.standortEmail').find('input').val(emailAddress)
			});
		}
	}
	if ($('.platz-anfragen').length > 0) {
	    var platzAnfrageValue = encodeURIComponent($('.standort_title').text());
	    var emailElement = $('.standort-email').find('a');
	    var emailAddress = emailElement.length > 0 ? encodeURIComponent(emailElement[0].innerHTML) : '';
	    var _href = $('.platz-anfragen').find('a').attr("href");
	    $('.platz-anfragen').find('a').attr('href', _href + "#" + platzAnfrageValue + '?mail=' + emailAddress)
}
if (window.location.hash.startsWith('#KiMi') === true) {
    $('.platzanfrage').ready(function () {
        setTimeout(function () {
            if (!$('.platzanfrage').hasClass('is-open')) {
                $('.platzanfrage').addClass('is-open')
                $('.platzanfrage').find('.c-accordion__content').removeAttr('hidden')
                $('.platzanfrage').find('.c-accordion__content').show();
            }
            var hash = window.location.hash
            var toFilter = hash.substring(hash.indexOf('#') + 1);
            var standortEmail = decodeURIComponent(toFilter.substring(toFilter.indexOf('mail=') + 5));
            var standortName = decodeURIComponent(toFilter.substring(0, toFilter.indexOf('?')));
            $("select[name='KitaAuswahl']").val(standortName)
            $('.standort_email').find('input').val(standortEmail)
            displayAvailableOptions()
        }, 500);
    });

	}
	if ($("select[name='KitaAuswahl']").val() === "Wählen deine Kita") {
		$("select[name='KitaAuswahl'] option:lt(1)").attr("disabled", true);
	}
	$("select[name='KitaAuswahl']").on('change', function (e) {
		displayAvailableOptions();
	});

	if ($('.single-posts-mother-wrapper').find('.single-post').length <= 0) {
		$('.single-posts-mother-wrapper').addClass('display-none');
		$('.unten-aktuelles').css('background-color', 'white');
	}
	//KONTAKT END
	// Start slider Standorte
			let startX;
			let endX;

			$('.carousel').on('mousedown', function(e) {
				startX = e.clientX;
			});

			$('.carousel').on('mouseup', function(e) {
				endX = e.clientX;
				handleSwipe();
			});

			function handleSwipe() {
				if (startX > endX) {
					$('.carousel').carousel('next');
				} else {
					$('.carousel').carousel('prev');
				}
			}
	// END NEW Script Standorte
})


// Header & Hamburger are initialized on every page
// Mansory Layout is loaded of needed Pages (Jobs, News)
function init(){
	initHeader();
	initHamburger();

	if (top.location.pathname === '/jobs/' || top.location.pathname === '/news/') {
		generateMansory();
	}
}

// Header is first define on PageLoad and needs to be updated on Scroll and Resize Events
function initHeader(){
	Header();
	$(window).on('scroll resize', debounce(Header,200));
}

function Header(){
	var mapsContainer = $('.pac-container')
	var mobileContainer = $('.mobile--menu-footer .header-suchen')
	if ($(window).scrollTop() >= 1) {
		$('#fixed').addClass('fixed-header');
	}
	else {
		$('#fixed').removeClass('fixed-header');
	}
	if ($(window).scrollTop() >= 1 && ($(window).width() >= 1024 && top.location.pathname != '/kimi_standort/')) {
		mapsContainer.appendTo("#fixed");
	}
	else if ($(window).scrollTop() <= 1 && ($(window).width() >= 1024 && top.location.pathname != '/kimi_standort/')) {
		mapsContainer.appendTo("body");
	}
	if ($(window).width() < 1024 && top.location.pathname != '/kimi_standort/') {
		mapsContainer.appendTo(mobileContainer);
	}
}

// When clicking on the Hamburger the active Class is toggle to show/hide menu
function initHamburger() {
	var $hamburger = $('.hamburger');
	$hamburger.on('click', function () {
		// Keine is-active Klasse mehr toggeln, nur noch ggf. Map-Container verschieben
		setTimeout(function () {
			var mapsContainer = $('.pac-container')
			var mobileContainer = $('.mobile--menu-footer .header-suchen')
			mapsContainer.appendTo(mobileContainer);
		}, 500);
	});
}

// The Mansory-Layout needs to be updated, when the content changed (filtering of News/Jobs)
// The height of the Layout needs also be calculated, when the window is resized
function generateMansory(){
	$( document ).ajaxComplete(function() {
		calculateHeightMansory();
	});

	$(window).on('resize',function () {
		calculateHeightMansory();
	});
}

// Calculation of the height for the Masonry Layout.
// For Small Windows (Mobil) only one column is displayed --> 100%
// When two columns are displayed, the height needs to be set to the higher height
// of the both columns (Every second post is in the right column).
function calculateHeightMansory() {
	if($(window).width() < 1200){
		$('.kimi-posts-wrapper').height('100%');
		return;
	}

	var total_jobs_height = 0;
	var total_jobs_height_odd = 0;
	var total_jobs_height_even = 0;
	$.each($('.kimi-post-wrapper:nth-child(2n+1)'), function () {
		total_jobs_height_odd += $(this).outerHeight(true);
	})
	$.each($('.kimi-post-wrapper:nth-child(2n+2)'), function () {
		total_jobs_height_even += $(this).outerHeight(true);
	})
	if (total_jobs_height_odd > total_jobs_height_even) {
		total_jobs_height = total_jobs_height_odd;
	}
	else {
		total_jobs_height = total_jobs_height_even;
	}
	$('.kimi-posts-wrapper').height(total_jobs_height);
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function () {
		var context = this, args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	}
}

// START NEW MAGAZIN SCRIPT
document.addEventListener("DOMContentLoaded", () => {
	const loadmore = document.querySelector('#loadmoreMagazin');
	let currentItems = 12;

	// Check if loadmore element is found
	if (loadmore) {
		loadmore.addEventListener('click', (e) => {
			const elementList = [...document.querySelectorAll('.magazin-article-grid--new .magazin-article-grid__single--new')];
			for (let i = currentItems; i < currentItems + 12; i++) {
				if (elementList[i]) {
					elementList[i].style.display = 'block';
				}
			}
			currentItems += 12;

			// Load more button will be hidden after list fully loaded
			if (currentItems >= elementList.length) {
				event.target.style.display = 'none';
			}
		});
	} else {
		console.log("Element with ID 'loadmore' not found.");
	}
});

// END NEW MAGAZIN SCRIPT


// START NEW JOB SCRIPT
$(document).ready(function () {                //run when the DOM is ready
	$(".button--bewerben").click(function() {  //use a class, since your ID gets mangled
		$(this).addClass("display--none");
		$(".awsm-job-form").addClass("display--block");      //add the class to the clicked element
	});
});


function loadElementClick() {
  const loadmore = document.querySelector('#loadmore');
  const elementList = document.querySelectorAll('.awsm-job-listings .awsm-job-listing-item');
  const elementArray = Array.from(elementList);

  if (loadmore === null) {
    // Wenn der Button nicht existiert, alle Elemente auf "display: block" setzen
    elementArray.forEach(function(element) {
      element.classList.add('block--display');
    });
  } else {
    // Wenn der Button existiert, auf "click"-Ereignisse hören
    loadmore.addEventListener('click', (e) => {
      // Alle versteckten Elemente sichtbar machen
      elementArray.forEach(function(element) {
        element.classList.add('block--display');
      });
      // "Load more"-Button ausblenden, wenn alle Elemente angezeigt werden
      if (elementList.length === elementArray.filter(element => !element.classList.contains('block--display')).length) {
        loadmore.style.display = 'none';
      }
    });
  }
}


function faqElementClick() {
var container = $(".awsm-job-listings");
	 var items = $(".awsm-job-listing-item");
$(".awsm-job-listing-item").each(function() {
// Convert the string in 'data-event-date' attribute to a more
// standardized date format
var BCDate = $(this).attr("data-event-date");
/*console.log(BCDate);
var standardDate = BCDate[1]+" "+BCDate[0]+" "+BCDate[2];*/
var standartDate = new Date(BCDate).getTime();
$(this).attr("data-event-date", standartDate);
});
}

function faqElementClickDate() {
var container = $(".awsm-job-listings");
	 var items = $(".awsm-job-listing-item");
$(".awsm-job-listing-item").each(function() {
// Convert the string in 'data-event-date' attribute to a more
// standardized date format
var BCDate = $(this).attr("data-name-date");
/*console.log(BCDate);
var standardDate = BCDate[1]+" "+BCDate[0]+" "+BCDate[2];*/
var standartDate = new Date(BCDate).getTime();
$(this).attr("data-name-date", standartDate);
});
}

$(document).ready(faqElementClickDate);
$(document).ajaxComplete(faqElementClickDate);
$(document).ready(faqElementClick);
$(document).ajaxComplete(faqElementClick);
$(document).ready(loadElementClick);
$(document).ajaxComplete(loadElementClick);
// END NEW JOB SCRIPT
// Karriere Page Scripts
jQuery(document).ready(function() {
  function scrollToTarget(target) {
    var headerHeight = jQuery('header').outerHeight();
    var extraOffset = 24; // zusätzlicher Abstand nach oben
    if (target.length) {
      jQuery('html, body').animate({
        scrollTop: target.offset().top - headerHeight - extraOffset
      }, 200);
    }
  }

  jQuery('a[href^="#"]').click(function(e) {
    e.preventDefault();
    var target = jQuery(this.hash);
    scrollToTarget(target);
  });

  setTimeout(function() {
    if (location.hash) {
			var hash = location.hash.split('?')[0].replace('%20', '_');
			var target = jQuery(hash);
			if (target.length) {
			scrollToTarget(target);
    	}
		}
  }, 1000);
});
jQuery(document).ready(function() {
  var delay = 700;
  var classNames = ['two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen', 'twenty', 'twentyone', 'twentytwo', 'twentythree', 'twentyfour'];

  // Einblenden von 'two', 'three' und 'four'
  jQuery('div.animation--two').css({
    opacity: 1,
    visibility: 'visible'
  });
  setTimeout(function() {
    jQuery('div.animation--three').css({
      opacity: 1,
      visibility: 'visible'
    });
  }, delay);
  setTimeout(function() {
    jQuery('div.animation--four').css({
      opacity: 1,
      visibility: 'visible'
    });
  }, delay * 2);

  // Einblenden von Elementen beim Scrollen
  jQuery(window).scroll(function() {
    jQuery.each(classNames, function(index, className) {
      var element = jQuery('div.animation--' + className);
      if (element.length && jQuery(window).scrollTop() + jQuery(window).height() > element.offset().top) {
        setTimeout(function() {
          element.css({
            opacity: 1,
            visibility: 'visible'
          });
        }, 500);
      }
    });
  });
});

// === Masonry für News-Archive (.kimi-posts-wrapper) ===
function initMasonryNews() {
  var grid = document.querySelector('.kimi-posts-wrapper');
  if(grid && window.Masonry) {
    new Masonry(grid, {
      itemSelector: '.kimi-post-wrapper',
      columnWidth: '.grid-sizer',
      percentPosition: true,
      gutter: 32,
      horizontalOrder: true
    });
  }
}

document.addEventListener('DOMContentLoaded', initMasonryNews);

if (window.jQuery) {
  jQuery(document).ajaxComplete(function(event, xhr, settings) {
    if (jQuery('.kimi-posts-wrapper').length) {
      initMasonryNews();
    }
  });
}
